import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatButtonModule } from '@angular/material/button';
import {
  ExactSchedule,
  getScheduleInterval,
  Schedule,
  ScheduleMode,
} from '../../../../api/_lib/schedule.js';
import { RouterLink } from '@angular/router';
import { CourseCatalogueDetailsCardComponent } from '../../../courses/course-catalogue-detail/course-catalogue-details-card/course-catalogue-details-card.component.js';
import {
  DateInterval,
  extractFullDateLabel,
  extractTimeLabel,
  extractWeekday,
  formatTableDate,
  FormatTableDatePipe,
} from '../../../../util/date.js';
import { eachDayOfInterval, setHours, setMinutes } from 'date-fns';

@Component({
  selector: 'app-workshop-catalogue-detail-schedule',
  standalone: true,
  imports: [
    MatIconModule,
    AngularSvgIconModule,
    MatButtonModule,
    RouterLink,
    CourseCatalogueDetailsCardComponent,
    FormatTableDatePipe,
  ],
  templateUrl: './workshop-catalogue-detail-schedule.component.html',
})
export class WorkshopCatalogueDetailScheduleComponent {
  schedule = input.required<Schedule>();
  text = computed(() => {
    const schedule = this.schedule();
    return getAfterSchoolScheduleText(schedule);
  });

  listSchedule = computed(() => {
    const schedule = this.schedule();
    return getAfterSchoolScheduleList(schedule);
  });
}

export function getAfterSchoolScheduleText(schedule: Schedule) {
  const firstSentence = $localize`The lessons take place from ${formatTableDate(getScheduleInterval(schedule).start)} to ${formatTableDate(getScheduleInterval(schedule).end)}`;

  if (schedule.mode === ScheduleMode.Default) {
    return firstSentence;
  }

  const weekdaysArray =
    (schedule as ExactSchedule).defaultWeeklySchedule?.map((wd) => {
      return $localize`${extractWeekday(wd.weekday, true)} from ${formatTableDate(wd.start, 'HH:mm')} to ${formatTableDate(wd.end, 'HH:mm')}`;
    }) ?? [];

  const weekdaysText =
    weekdaysArray.slice(0, -1).join(', ') +
    (weekdaysArray.length > 1 ? ' and ' : '') +
    weekdaysArray.slice(-1);

  return $localize`${firstSentence}, every ${weekdaysText}. The exact dates and times can be found below:`;
}

export function getAfterSchoolScheduleList(schedule: Schedule) {
  if (schedule.mode === ScheduleMode.Exact) {
    return (schedule as ExactSchedule).schedule.map((interval) => {
      return `${extractFullDateLabel(interval.start)}: ${extractTimeLabel(interval.start)} - ${extractTimeLabel(interval.end)}`;
    });
  }

  const interval = schedule.schedule as DateInterval;
  return eachDayOfInterval(interval).map((day) => {
    const start = setHours(setMinutes(day, 0), 8);
    const end = setHours(setMinutes(day, 0), 17);
    return `${extractFullDateLabel(start)}: ${extractTimeLabel(start)} - ${extractTimeLabel(end)}`;
  });
}
